<boi-mortgage-app-section-navigation #boiTabWrapper (detectChanges)="changeDetectorRef.detectChanges()">
  <div class="title-bar">
    <h1 class="title-bar-text vo-heading-regular-22">{{referenceDataLabels.SectionTitleProperty | localizeLabel}}</h1>

    <span
      class="required-label vo-body-regular-14 vo-display-none"
      [innerHtml]="referenceDataLabels.MandatoryFields | localizeLabel"
    ></span>
  </div>

  <ng-container *ngIf="mortgageApplication?.IsFullApp">
    <boi-form-information-box [message]="referenceDataLabels.DetailsAboutYourProperty"></boi-form-information-box>
  </ng-container>

  <ng-container *ngIf="mortgageApplication?.IsAip || mortgageApplication?.IsFactFind">
    <boi-form-information-box [message]="referenceDataLabels.DetailsAboutYourPropertyAip"> </boi-form-information-box>
  </ng-container>

  <boi-accordion>
    <boi-accordion-item
      #accordionItem1
      [title]="referenceDataLabels.AboutProperty | localizeLabel"
      [class]="'js-section-' + referenceDataLabels.AboutProperty | removeWhiteSpaces"
      [data]="sections.YourProperty.AboutTheProperty"
    >
      <boi-progress-stepper-item
        header
        [status]="sections.YourProperty.AboutTheProperty"
        [hasSubmitValidationError]="hasSubmitValidationError"
      >
      </boi-progress-stepper-item>
      <boi-your-property-details></boi-your-property-details>
      <ng-container *ngIf="!mortgageApplication.isUnregisteredFactFind">
        <boi-save-application
          class="buttons__bar"
          [saveButtonLabel]="saveContinueButtonLabel"
          [hideActionButton]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)"
          (cancel)="boiTabWrapper.goToSection(referenceDataLabels.AboutProperty)"
          (save)="boiTabWrapper.goToNextIncompleted(accordionItem1)"
        >
        </boi-save-application>
      </ng-container>
      <ng-container *ngIf="mortgageApplication.isUnregisteredFactFind">
        <div class="buttons__bar d-flex flex-row-reverse">
          <button
            (click)="submitUnregisteredFactFind()"
            class="primary-button vo-primary-button-1 full-width-md-button"
            [innerHTML]="referenceDataLabels.FinishAndSubmit | localizeLabel"
          ></button>
        </div>
      </ng-container>
    </boi-accordion-item>
    <ng-container *ngIf="mortgageApplication.IsFullApp && mortgageApplication.isPurchase">
      <div class="vo-separator-line my-15"></div>
      <boi-accordion-item
        #accordionItem2
        [title]="referenceDataLabels.PropertyContacts | localizeLabel"
        [class]="'js-section-' + referenceDataLabels.PropertyContacts | removeWhiteSpaces"
        [data]="sections.YourProperty.PropertyContacts"
      >
        <boi-progress-stepper-item
          header
          [status]="sections.YourProperty.PropertyContacts"
          [hasSubmitValidationError]="hasSubmitValidationError"
        >
        </boi-progress-stepper-item>
        <boi-your-property-contacts></boi-your-property-contacts>
        <boi-save-application
          class="buttons__bar"
          [saveButtonLabel]="saveContinueButtonLabel"
          [hideActionButton]="mortgageApplication?.IsApplicationReadOnly"
          (cancel)="boiTabWrapper.goToSection(referenceDataLabels.PropertyContacts)"
          (save)="boiTabWrapper.goToNextIncompleted(accordionItem2)"
        >
        </boi-save-application>
      </boi-accordion-item>
    </ng-container>
    <ng-container *ngIf="mortgageApplication.IsFullApp">
      <div class="vo-separator-line my-15"></div>
      <boi-accordion-item
        #accordionItem3
        [title]="referenceDataLabels.LegalSupport | localizeLabel"
        [class]="'js-section-' + referenceDataLabels.LegalSupport | removeWhiteSpaces"
        [data]="sections.YourProperty.LegalSupport"
      >
        <boi-progress-stepper-item
          header
          [status]="sections.YourProperty.LegalSupport"
          [hasSubmitValidationError]="hasSubmitValidationError"
        ></boi-progress-stepper-item>
        <boi-your-property-legal-support></boi-your-property-legal-support>
        <boi-save-application
          class="buttons__bar"
          [saveButtonLabel]="saveContinueButtonLabel"
          [hideActionButton]="mortgageApplication?.IsApplicationReadOnly"
          (cancel)="boiTabWrapper.goToSection(referenceDataLabels.LegalSupport)"
          (save)="boiTabWrapper.goToNextIncompleted(accordionItem3)"
        >
        </boi-save-application>
      </boi-accordion-item>
    </ng-container>
    <ng-container *ngIf="!mortgageApplication.IsFactFind">
      <div class="vo-separator-line my-15"></div>
      <boi-accordion-item
        #accordionItem4
        [title]="referenceDataLabels.AnyAdditionalInformation | localizeLabel"
        [class]="'js-section-' + referenceDataLabels.AnyAdditionalInformation | removeWhiteSpaces"
        [data]="sections.YourProperty.AnyAdditionalInfo"
      >
        <boi-progress-stepper-item
          header
          [status]="sections.YourProperty.AnyAdditionalInfo"
          [hasSubmitValidationError]="hasSubmitValidationError"
        >
        </boi-progress-stepper-item>
        <boi-your-property-additional-info></boi-your-property-additional-info>
        <boi-save-application
          class="buttons__bar"
          [saveButtonLabel]="saveContinueButtonLabel"
          [hideActionButton]="mortgageApplication?.IsApplicationReadOnly"
          (cancel)="boiTabWrapper.goToSection(referenceDataLabels.AnyAdditionalInformation)"
          (save)="boiTabWrapper.goToNextIncompleted(accordionItem4)"
        >
        </boi-save-application>
      </boi-accordion-item>
    </ng-container>
  </boi-accordion>
</boi-mortgage-app-section-navigation>
